<!-- Toast Notifications -->
<app-notification-toasts-container />

<!-- Top nav -->
@if (showTopNav) {
  <app-top-nav />
}

<mat-sidenav-container
  [ngClass]="{
    'mt-0 h-screen': !showTopNav,
    'mt-16 h-calc': showTopNav,
    'backdrop-drawer': showSideNav
  }"
  hasBackdrop="true"
>
  <!-- Side nav -->
  <mat-sidenav #sidenav mode="over" class="flex flex-col h-full !w-[360px]">
    @if (sidenavDrawerService.isSideNavOpen() && showSideNav && userLogged) {
      <app-menu-drawer [isArchitect]="userService.isAdmin" />
    }
  </mat-sidenav>

  <!-- Main page content -->
  <mat-sidenav-content
    class="flex-auto bg-gray-50"
    [ngClass]="{ 'non-entry': showTopNav, dark: darkEnabled }"
  >
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- The container only covers the viewport while a backdrop is actually being shown.
     `mat-drawer-container` has no height of its own, and its one child here is
     `position: fixed`, so the container collapses to zero — and the backdrop inside it,
     which is `position: absolute; inset: 0`, collapses with it. Measured: 1888x0. The
     backdrop was rendered and had nothing to click.

     Bound rather than always on, because a permanently full-screen element at z-2000 would
     swallow every click on the page when no drawer is open.

     `!fixed`/`!inset-0`, not `fixed`/`inset-0`. Material styles `.mat-drawer-container` with
     `position: relative`, at the same specificity as a Tailwind utility — and it wins on
     order, because component styles are injected into the head at runtime while the utility
     sits in the stylesheet linked ahead of them. Written without the `!` the container stayed
     `relative`, kept its zero height, and the backdrop went back to having nothing to click:
     the panel closed on its ✕ and on Escape but not on a click away from it. Every other
     override in this class list carries the `!` for the same reason. -->
<mat-drawer-container
  class="!bg-transparent right-0 bottom-0 !z-[2000]"
  [ngClass]="{
    '!fixed !inset-0':
      sidenavDrawerService.drawerHasBackdrop() &&
      sidenavDrawerService.isDrawerOpen(),
    'scrimless-backdrop': widgetHistoryOpen()
  }"
  [hasBackdrop]="sidenavDrawerService.drawerHasBackdrop()"
>
  <mat-drawer
    #rightDrawer
    class="!fixed !bg-white !top-0 !z-[2000]"
    id="right-drawer"
    mode="over"
    position="end"
    (closedStart)="restoreDrawerAfterWidgetHistory()"
  >
    <app-info-drawer [isUsedFromMap]="isMap()" />
  </mat-drawer>
</mat-drawer-container>

<!-- Ariadne floating assistant — signed in, and only on main app surfaces (hidden on print/export
     routes so their rendered output no longer inherits the floating icon). -->
@if (userLogged && isMainSurface()) {
  <app-ariadne-chat-frame />
}
